import {
  BooleanOrNullOrUndefined,
  DateOrNullOrUndefined,
  NumberOrNullOrUndefined,
  StringOrNullOrUndefined,
} from 'src/app/shared/utils';

export class PaServiceV2 {
  id: number = 0;
  patient_id: number = 0;
  patient_name?: string;
  pa_service: string = '';
  cpt: string = '';
  n_units: number = 0;
  spent_units: number = 0;
  weekly_units_limit?: number;
  start_date: Date = new Date();
  end_date: Date = new Date();
  created_at?: Date;
  updated_at?: Date;
  deleted_at?: Date;
  deleted?: boolean;
  insurance_id?: number;
  insurance_name?: string;
  is_primary?: boolean;
  available_units?: number;
  constructor(data: Partial<PaServiceV2> = {}) {
    this.id = NumberOrNullOrUndefined(data.id) ?? 0;
    this.patient_id = NumberOrNullOrUndefined(data.patient_id) ?? 0;
    this.patient_name = StringOrNullOrUndefined(data.patient_name);
    this.pa_service = StringOrNullOrUndefined(data.pa_service) ?? '';
    this.cpt = StringOrNullOrUndefined(data.cpt) ?? '';
    this.n_units = NumberOrNullOrUndefined(data.n_units) ?? 0;
    this.available_units = NumberOrNullOrUndefined(data.available_units);
    this.spent_units = NumberOrNullOrUndefined(data.spent_units) ?? 0;
    this.weekly_units_limit = NumberOrNullOrUndefined(data.weekly_units_limit);
    this.start_date = DateOrNullOrUndefined(data.start_date) ?? new Date();
    this.end_date = DateOrNullOrUndefined(data.end_date) ?? new Date();
    this.created_at = DateOrNullOrUndefined(data.created_at);
    this.updated_at = DateOrNullOrUndefined(data.updated_at);
    this.deleted_at = DateOrNullOrUndefined(data.deleted_at);
    this.insurance_id = NumberOrNullOrUndefined(data.insurance_id);
    this.insurance_name = StringOrNullOrUndefined(data.insurance_name);
    this.is_primary = BooleanOrNullOrUndefined(data.is_primary);
  }
}
